<template>
  <billing-dialog
    class="zwb-plan-details"
    :visible.sync="visible"
    :before-close="handleBeforeClose"
    @back-event="handleBeforeClose"
  >
    <BasePlanDetails>
      <span slot="title">{{ title }}</span>
      <template #price>
        <price-list class="zwb-plan-details__price-list" :showDecimalPoint="$context.is.desktop" :plan-category="planCategory" :unit-type="planUnitMap.license"/>
      </template>
      <ul slot="desc">
        <li v-for="item in descList" :key="item">{{ item }}</li>
      </ul>
      <zm-button data-testid="checkout-button-258" slot="action" type="link" class="plan-details__confirm-btn text-capitalize" @click="handleSure">
        {{ $t('billing.pbx.plan_details.view_more') }}
      </zm-button>
    </BasePlanDetails>
  </billing-dialog>
</template>
<script type="text/jsx">
import BasePlanDetails from '@/plans/EVENT_SAAS/component/dialog/plan-details/base.vue';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { planTypes, trackingPlanTypes } from '@/common/constants';
import { get } from 'lodash';
import PriceList from "@/components/price-list.vue";
import { planUnitMap } from '@/common/product-unit';
import BillingDialog from '@/components/billing-dialog.vue';

export default {
  name: 'PlanDetails',
  mixins: [ConfirmComponent],
  components: {
    BillingDialog,
    PriceList,
    BasePlanDetails,
  },
  props: {
    planList: Array,
    planType: String,
    title: String,
    planCategory: String,
  },
  data() {
    return {
      visible: false,
      planUnitMap
    };
  },
  methods: {
    handleSure() {
      this.$tracking.buyInteraction('product details',
        `${this.trackingPlanKey} plan details -  view more`);
    },
    handleBeforeClose() {
      this.$tracking.buyInteraction('product details',
        `${this.trackingPlanKey} plan details - exit`);
      this.handleCancel();
    },
  },
  computed: {
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
    descList() {
      return {
        [planTypes.ZOOM_WHITEBOARD]: [
          this.$t('unlmitedConcurrentlyEditableWhiteboards'),
          this.$t('standardFeaturesAndAdvancedDocumentControl'),
          this.$t('canBeAddedToZoomOneBasicOrProPlans'),
        ],
        [planTypes.ZOOM_WHITEBOARD_PLUS]: [
          this.$t('billing.zoom_whiteboard.unlimited_concurrently_editable_whiteboards'),
          this.$t('advancedWhiteboardFeatures')
        ],
      }[this.planType]
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        v && this.$tracking.buyInteraction('product details', `${this.trackingPlanKey} plan details - impression`);
      }
    }
  },
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.zwb-plan-details {
  .zm-dialog {
    padding: 72px 60px;
    min-width: 555px;
    width: fit-content;
  }

  .plan-details__price {
    display: flex;
  }

  &__price-list {
    @include media(mobile) {
      margin-top: 16px;
    }

    @include media(tablet) {
      margin-top: 4px;
    }
  }

  .plan-details__desc {
    padding-left: 20px;
    ul {
      list-style: disc;
      li {
        list-style: disc;
        color: #00053D;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        @include darkTextColor;
      }
    }
  }
}
</style>
